// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__-G4qB"};